import {auth} from './middleware';
const WatchedRoutes = [
	{
		name: 'WatchedAccountList',
		path: 'accounts',
		component: () => import('@/components/watched-items/accounts/AccountList.vue'),
		meta: { middleware: [ auth ] },
	},
	{
		name: 'WatchedHashtagList',
		path: 'hashtags',
		component: () => import('@/components/watched-items/hashtags/HashtagList.vue'),
		meta: { middleware: [ auth ] }

	},
	{
		name: 'WatchedPhraseList',
		path: 'phrases',
		component: () => import('@/components/watched-items/phrases/PhraseList.vue'),
		meta: { middleware: [ auth ] }

	},
	{
		name: 'WatchedMentionList',
		path: 'mentions',
		component: () => import('@/components/watched-items/mentions/MentionList.vue'),
		meta: { middleware: [ auth ] }

	},
	{
		name: 'WatchedAccountCreate',
		path: 'accounts/create',
		component: () => import('@/components/watched-items/accounts/AccountForm.vue'),
		meta: { middleware: [ auth ] }
	},
	{
		name: 'WatchedHashtagCreate',
		path: 'hashtags/create',
		component: () => import('@/components/watched-items/hashtags/HashtagForm.vue'),
		meta: { middleware: [ auth ] }
	},
	{
		name: 'WatchedPhraseCreate',
		path: 'phrases/create',
		component: () => import('@/components/watched-items/phrases/PhraseForm.vue'),
		meta: { middleware: [ auth ] }
	},
	{
		name: 'WatchedMentionCreate',
		path: 'mentions/create',
		component: () => import('@/components/watched-items/mentions/MentionForm.vue'),
		meta: { middleware: [ auth ] }
	}
]


export default WatchedRoutes;